import React from 'react';

import MetaTags from 'components/meta-tags';
import { CircleStar } from 'src/assets/circle-star';
import { IrlEventTrackingEvent } from 'src/gql/graphql';
import { Card } from './card';
import { ContentHeader, Heading, Description, ShopNowButton, LogoWrapper, Content } from './styles';
import { useIrlEventTracking } from '../hooks/use-irl-event-tracking';

type IrlEventNotStartedProps = {
  shopNowUrl: string | null;
};

const NOT_STARTED_TITLE = "This event hasn't started yet";
const NOT_STARTED_DESCRIPTION = 'Come back when the event begins to sign up and receive your event reward.';

export function IrlEventNotStarted({ shopNowUrl }: IrlEventNotStartedProps): JSX.Element {
  const { trackEvent } = useIrlEventTracking();

  const handleShopNowClick = (): void => {
    void trackEvent(IrlEventTrackingEvent.shopNowClicked);
  };

  return (
    <>
      <MetaTags title={NOT_STARTED_TITLE} description={NOT_STARTED_DESCRIPTION} />

      <Card data-testid='irl-event-not-started'>
        <LogoWrapper $showError>
          <CircleStar />
        </LogoWrapper>

        <ContentHeader>
          <Heading>{NOT_STARTED_TITLE}</Heading>
          <Description>{NOT_STARTED_DESCRIPTION}</Description>
        </ContentHeader>

        <Content narrow>
          {shopNowUrl && (
            <ShopNowButton
              href={shopNowUrl}
              target='_blank'
              rel='noopener noreferrer'
              variant='primary'
              size='large'
              onClick={handleShopNowClick}
              data-testid='irl-event-not-started-shop-now-button'
            >
              Shop Now
            </ShopNowButton>
          )}
        </Content>
      </Card>
    </>
  );
}
